export const COMMON_LOCALES = {
  dashboardTabLabel: "Dashboard",
  organizationSettingsTabLabel: "Organization",
  settingsTabLabel: "Settings",
  profileSettingsTabLabel: "Profile",
  subscriptionSettingsTabLabel: "Subscription",
  dashboardTabDescription:
    "An overview of your organization's activity and performance across all your projects.",
  settingsTabDescription: "Manage your settings and preferences.",
  emailAddress: "Email Address",
  password: "Password",
  modalConfirmationQuestion: "Are you sure you want to continue?",
  imageInputLabel: "Click here to upload an image",
  cancel: "Cancel",
  genericServerError: "Sorry, something went wrong.",
  genericServerErrorHeading:
    "Sorry, something went wrong while processing your request. Please contact us if the issue persists.",
  pageNotFound: "Ops. Page not Found.",
  pageNotFoundSubHeading:
    "Apologies, the page you were looking for was not found",
  genericError: "Sorry, something went wrong.",
  genericErrorSubHeading:
    "Apologies, an error occurred while processing your request. Please contact us if the issue persists.",
  anonymousUser: "Anonymous",
  tryAgain: "Try Again",
  theme: "Theme",
  lightTheme: "Light",
  darkTheme: "Dark",
  systemTheme: "System",
  expandSidebar: "Expand Sidebar",
  collapseSidebar: "Collapse Sidebar",
  documentation: "Documentation",
  getStarted: "Get Started",
  retry: "Retry",
  contactUs: "Contact Us",
  loading: "Loading. Please wait...",
  yourOrganizations: "Your Organizations",
  continue: "Continue",
  skip: "Skip",
  roles: {
    owner: {
      label: "Owner",
      description:
        "Can change any setting, invite new members and manage billing",
    },
    admin: {
      label: "Admin",
      description:
        "Can change some settings, invite members, perform disruptive actions",
    },
    member: {
      label: "Member",
      description: "Cannot invite members or change settings",
    },
  },
};
